import styled from 'styled-components'

import { fromMd, mdStartPixels, pageLayoutMaxWidthPixels } from '@syconium/little-miss-figgy'

export const Main = styled.main``

export const Section = styled.section`
  max-width: ${pageLayoutMaxWidthPixels}px;
  margin-left: auto;
  margin-right: auto;
`

export const PrimaryAndAsideSection = styled(Section)`
  display: grid;
  grid-template-columns: minmax(min(100%, ${mdStartPixels}px), 1fr);
  row-gap: ${props => props.theme.spacing(6)};
  column-gap: ${props => props.theme.spacing(6)};
  margin-bottom: ${props => props.theme.spacing(5)};

  ${fromMd} {
    margin-bottom: ${props => props.theme.spacing(10)};
    grid-template-columns: minmax(0px, 2fr) minmax(0px, 1fr);
    padding-left: ${props => props.theme.spacing(10)};
    padding-right: ${props => props.theme.spacing(10)};
  }
`

export const PrimaryColumnDiv = styled.div`
  grid-column: span 1;
`

export const AsideColumnDiv = styled.div`
  grid-column: span 1;
`

export const Recommendations = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${pageLayoutMaxWidthPixels}px;
  margin: 0 auto;
  gap: ${o => o.theme.spacing(5)};
  ${fromMd} {
    gap: ${o => o.theme.spacing(10)};
  }

  /* Only apply margin to top of recommendations section if it has children */
  &:not(:empty) {
    margin-top: ${o => o.theme.spacing(5)};
    ${fromMd} {
      margin-top: ${o => o.theme.spacing(10)};
    }
  }
`
